"use client";

export default function TermsAndConditions() {
	return (
		<div className="min-h-full bg-mgt-black px-4 py-8 md:py-12">
			<div className="max-w-4xl mx-auto">
				<div className="text-center mb-12">
					<h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
						Terms and Conditions
					</h1>
					<p className="text-off-white text-lg">
						Please read these terms carefully before using MyGeoTokens
					</p>
				</div>

				<div className="bg-brown rounded-2xl p-6 md:p-8 space-y-8 text-white">
					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							1. Eligibility
						</h2>
						<p className="text-off-white leading-relaxed">
							You must be at least 18 years old or the age of majority in your
							jurisdiction to use our services. By accessing our platform, you
							confirm you meet these age requirements.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							2. Web3 Wallet Connection
						</h2>
						<p className="text-off-white leading-relaxed mb-4">
							Our platform requires connection to a non-custodial Web3 wallet
							such as MGT Wallet or Solflare. You are solely responsible
							for:
						</p>
						<ul className="list-disc list-inside text-off-white space-y-2 ml-4">
							<li>Maintaining the security of your wallet and private keys</li>
							<li>All transactions initiated from your connected wallet</li>
							<li>
								Ensuring your wallet is compatible with the Solana blockchain
							</li>
						</ul>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							3. No Custody or Control
						</h2>
						<p className="text-off-white leading-relaxed">
							MyGeoTokens operates as a decentralized application interface. We
							do not have access to your wallet, private keys, or the ability to
							reverse, cancel, or modify any blockchain transactions. All
							transactions are final and irreversible.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							4. User Responsibility
						</h2>
						<p className="text-off-white leading-relaxed mb-4">
							You acknowledge and agree that you are solely responsible for:
						</p>
						<ul className="list-disc list-inside text-off-white space-y-2 ml-4">
							<li>
								Verifying the accuracy of wallet addresses before transactions
							</li>
							<li>Understanding blockchain technology and associated risks</li>
							<li>Paying all applicable network fees and gas costs</li>
							<li>Compliance with applicable laws in your jurisdiction</li>
						</ul>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							5. No Financial Advice
						</h2>
						<p className="text-off-white leading-relaxed">
							Our platform provides software interface services only. Nothing on
							our platform constitutes financial, investment, or trading advice.
							All decisions regarding NFT purchases, sales, or trades are made
							entirely at your own risk.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							6. Assumption of Risk
						</h2>
						<p className="text-off-white leading-relaxed mb-4">
							By using our platform, you acknowledge and assume all risks
							associated with:
						</p>
						<ul className="list-disc list-inside text-off-white space-y-2 ml-4">
							<li>Blockchain technology and cryptocurrency volatility</li>
							<li>NFT market fluctuations and potential loss of value</li>
							<li>Smart contract vulnerabilities or failures</li>
							<li>Network congestion and transaction delays</li>
						</ul>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							7. Intellectual Property
						</h2>
						<p className="text-off-white leading-relaxed">
							All content, trademarks, and intellectual property on our platform
							belong to MyGeoTokens Inc. unless otherwise specified. You may not
							use our content without express written permission.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							8. Prohibited Uses
						</h2>
						<p className="text-off-white leading-relaxed mb-4">
							You agree not to use our platform for:
						</p>
						<ul className="list-disc list-inside text-off-white space-y-2 ml-4">
							<li>Any illegal activities or violation of applicable laws</li>
							<li>Spreading malware, viruses, or harmful code</li>
							<li>Impersonating others or providing false information</li>
							<li>Market manipulation or fraudulent activities</li>
						</ul>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							9. Disclaimer of Warranties
						</h2>
						<p className="text-off-white leading-relaxed">
							Our services are provided &quot;as is&quot; without warranties of
							any kind. We disclaim all warranties, express or implied,
							including but not limited to merchantability, fitness for a
							particular purpose, and non-infringement.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							10. Limitation of Liability
						</h2>
						<p className="text-off-white leading-relaxed">
							MyGeoTokens Inc. shall not be liable for any direct, indirect,
							incidental, special, or consequential damages arising from your
							use of our platform, including but not limited to loss of funds,
							NFTs, or data.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							11. Third-Party Services
						</h2>
						<p className="text-off-white leading-relaxed">
							Our platform may integrate with third-party services such as
							wallet providers, blockchain networks, and mapping services. We
							are not responsible for the availability, accuracy, or reliability
							of these third-party services.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							12. Modifications
						</h2>
						<p className="text-off-white leading-relaxed">
							We reserve the right to modify these terms at any time. Users will
							be notified of significant changes through our platform or via
							email. Continued use constitutes acceptance of modified terms.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							13. Governing Law
						</h2>
						<p className="text-off-white leading-relaxed">
							These terms are governed by the laws of Alberta, Canada. Any
							disputes will be resolved in the courts of Alberta, Canada.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							14. Contact Information
						</h2>
						<p className="text-off-white leading-relaxed">
							For questions about these terms, please join our Discord community
							at{" "}
							<a
								href="https://discord.gg/UpxTdUVkKy"
								target="_blank"
								rel="noopener noreferrer"
								className="text-mgt-green hover:text-mgt-yellow transition-colors"
							>
								discord.gg/UpxTdUVkKy
							</a>
						</p>
					</section>

					<div className="border-t border-off-white/20 pt-6 mt-8">
						<p className="text-sm text-off-white text-center">
							Last updated: May 11, 2026
						</p>
						<p className="text-sm text-off-white text-center mt-2">
							© {new Date().getFullYear()} MyGeoTokens Inc. All rights reserved.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}
